import { Component, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RosterShiftComponent } from '../roster-shift/roster-shift.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { JobService } from 'src/app/services/job/job.service';
import { CommonService } from 'src/app/services/common/common.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-add-unavailability',
  templateUrl: './add-unavailability.component.html',
  styleUrls: ['./add-unavailability.component.scss']
})
export class AddUnavailabilityComponent {
  public filterEmployeeArr: any[] = [];
  public addForm!: FormGroup;
  public frequencyType!: string;
  public repeatEveryArr: any[] = [];
  public endType!: string;
  public repeatArr: any[] = [
    { name: "First Sunday" },
    { name: "First Monday" },
    { name: "First Tuesday" },
    { name: "First Wednesday" },
    { name: "First Thursday" },
    { name: "First Friday" },
    { name: "First Saturday" },
    { name: "Second Sunday" },
    { name: "Second Monday" },
    { name: "Second Tuesday" },
    { name: "Second Wednesday" },
    { name: "Second Thursday" },
    { name: "Second Friday" },
    { name: "Second Saturday" },
    { name: "Last Sunday" },
    { name: "Last Monday" },
    { name: "Last Tuesday" },
    { name: "Last Wednesday" },
    { name: "Last Thursday" },
    { name: "Last Friday" },
    { name: "Last Saturday" },
    { name: "1st" },
    { name: "2nd" },
    { name: "3rd" },
    { name: "4th" },
    { name: "5th" },
    { name: "6th" },
    { name: "7th" },
    { name: "8th" },
    { name: "9th" },
    { name: "10th" },
    { name: "11th" },
    { name: "12th" },
    { name: "13th" },
    { name: "14th" },
    { name: "15th" },
    { name: "16th" },
    { name: "17th" },
    { name: "18th" },
    { name: "19th" },
    { name: "20th" },
    { name: "21st" },
    { name: "22nd" },
    { name: "23rd" },
    { name: "24th" },
    { name: "25th" },
    { name: "26th" },
    { name: "27th" },
    { name: "28th" },
    { name: "29th" },
    { name: "30th" },
    { name: "31st" },
  ]
  public weekdaysArr: any[] = [
    { name: "Sunday", val: "S" },
    { name: "Monday", val: "M" },
    { name: "Tuesday", val: "T" },
    { name: "Wednesday", val: "W" },
    { name: "Thursday", val: "T" },
    { name: "Friday", val: "F" },
    { name: "Saturday", val: "S" },
  ]
  public weekFrequency: any[] = []
  public repeatText!: string;
  constructor(private dialogRef: MatDialogRef<AddUnavailabilityComponent>, @Inject(MAT_DIALOG_DATA) public dialogData: any, private fb: FormBuilder,
    private dialog: MatDialog, private jobService: JobService, private commonService: CommonService, private datePipe:DatePipe,) { }
  ngOnInit(): void {
    this.addForm = this.fb.group({
      unavailableAllDay: [false],
      st_dt: [''],
      st_ti: [''],
      ed_ti: [''],
      note: [''],
      filterEmployeeArr: [[]],
      employee_ids: [[]], 
      'frequency': [''],
      'every': [''],
      'monthFrequency': [''],
      'endFrequency': [''],
      'endDate': '',
      'occurrences': [''],
      'repeat': [''],
       dateRanges: this.fb.array([]) 
    })

    this.addDateRange();

    this.getEmployee()
    
  }

   // Method to get FormArray for date ranges
   get dateRanges(): FormArray {
    return this.addForm.get('dateRanges') as FormArray;
  }

  // Method to add a new date range
  addDateRange(): void {
    const dateRangeGroup = this.fb.group({
      st_ti: [''],
      ed_ti: ['']
    });
    this.dateRanges.push(dateRangeGroup);
  }
  // Method to remove a date range
  removeDateRange(index: number): void {
    this.dateRanges.removeAt(index);
  }
  onSubmit() {
    this.addUnavailability()
  }

  isToggleOn = false
  //this is for hour inputs if unavaibality all day is active then dont show hour fields
  onToggleChange(e:MatSlideToggleChange){
    this.isToggleOn = e.checked;
  }

  addUnavailability() {
    let data = {
      "repeat": "0", //1 = yes, 0 = no
      "r_typ": "0", //2=daily,1=weekly,0=monthly,
      "r_val": "2", //every some times 
      "r_on": [ 30 ], //[0,2,1] = weekly 
      "end_rtyp": "1", // 1=after, 0=on
      "end_r": "20",
      "emp": this.addForm.get('employee_ids')?.value,
      "st_dt": this.datePipe.transform(this.addForm.get('st_dt')?.value,'yyyy-MM-dd') ,
      // "ed_dt": "2024-08-16",
      "ed_dt": this.datePipe.transform(this.addForm.get('st_dt')?.value,'yyyy-MM-dd'),
      "un_avail": "0", // 0 = specific time 1 = full day
      "note": this.addForm.get('note')?.value,
      "time": this.dateRanges.value.map((range: any) => ({
        "st_ti": this.datePipe.transform(range.st_ti,"HH:mm"),
        "ed_ti": this.datePipe.transform(range.ed_ti,"HH:mm"),
      }))
    };
    if(this.addForm.get('unavailableAllDay')?.value==true){
      data['un_avail'] = "1";
    }   
  
    this.jobService.addUnavailablity(data).subscribe({
      next: (success: Object) => {
        // this.myApp.successToast(success.msg);
        if (success["status"] == 200) {
          // this.appService.showToastMessage("success", success["msg"]);
          this.dialogRef.close()
        }
      },
      error: (error: any) => {
        // this.spinner.hide();
        this.commonService.handleError(error);
      },
    });
  }

  getEmployee() {

    let data = {
      "date": [
      ],
      "j_c": "",
      "j_sc": "",
      "e_typ": "1", // 2 = favourite , 1 = all employee 
      "all_emp": "1",
      "j_id":""
    };

    this.jobService.getEmployee(data).subscribe({
      next: (success: Object) => {

        // this.myApp.successToast(success.msg);
        if (success["status"] == 200) {
          // this.appService.showToastMessage("success", success["msg"]);
          this.filterEmployeeArr = success["msg"].avl
        }
      },
      error: (error: any) => {
        // this.spinner.hide();
        this.commonService.handleError(error);
      },
    });
  }



  customSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.first_name.toLowerCase().indexOf(term) > -1 || item.last_name.toLowerCase().indexOf(term) > -1;
  }
  onSelectDay(item) {
    if (item.hasOwnProperty('isSelected')) {
      item.isSelected = true
    }
    else {
      item.isSelected = !item.isSelected;
    }
    const days = this.weekFrequency;
    const index = days.indexOf(item.name);
    if (index > -1) {
      days.splice(index, 1);
    } else {
      days.push(item.name);
    }
  }
  getRepeatEveryArr() {
    this.repeatEveryArr = []
    if (this.frequencyType == 'daily') {
      this.repeatEveryArr = Array.from({ length: 30 }, (_, i) => i + 1);
    }
    else if (this.frequencyType == 'monthly') {
      this.repeatEveryArr = Array.from({ length: 12 }, (_, i) => i + 1);
    }
    else {
      this.repeatEveryArr = Array.from({ length: 20 }, (_, i) => i + 1);
    }
    // if(this.addForm.get())
    this.addForm.get('every')?.setValue(this.repeatEveryArr[0]);
  }
  onEndType(event) {
    this.endType = event.value;
  }
  onCancel() {
    this.dialogRef.close();
  }
 
  onSelectFrequency(event) {
    this.frequencyType = event.value;
    this.getRepeatEveryArr()
  }
  addRoster() {
    const dialogRef = this.dialog.open(RosterShiftComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", minWidth: '280px', width: '30%'
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let fData = result.data;
        let fType: string = fData.frequency;
        this.repeatText = `Every ${fData.every} `
        if (fType == 'weekly') {
          this.repeatText = this.repeatText + 'weeks'
        }
        if (fType == 'monthly') {
          this.repeatText = this.repeatText + 'months'
        }
        if (fType == 'daily') {
          this.repeatText = this.repeatText + 'days'
        }
        if (fData.monthFrequency) {
          this.repeatText = this.repeatText + ' on ' + fData.monthFrequency
        }
        if (fData.weekFrequency) {
          let arr = fData.weekFrequency;
          let newText = arr.join(', ');
          this.repeatText = this.repeatText + ' on ' + newText;
        }
        if (fData.occurrences) {
          this.repeatText = this.repeatText + ' for ' + fData.occurrences + ' times';
        }
      }
    });
  }
} 
